import { Breadcrumb, Skeleton, Row, Col, Select } from 'antd';
import { ButtonAction, Card, Form, FormItem, GetValidateFields, Input, Toggle, Button, Tooltip, AsumsiIcon, Modal, Confirm } from 'asumsi-components';
import { LayoutCMS } from 'components';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useAction from '@pages/role-groups/hooks/useAction';
import useActionRoles from '@pages/roles/hooks/useAction';
import { IResponseRoles } from '@interfaces/iresponse-role';

export const PageRoleGroupsFormComponent = (props: any) => {
    const { Option } = Select;
    // set header page
    const title = 'Role Groups'
    const layoutCMSProps = {
        breadcrumb: (
            <>
                <Breadcrumb.Item>
                    {title}
                </Breadcrumb.Item>
            </>
        ),
        documentTitle: title,
        history: props.history,
        pageTitle: title,
    };

    // declare action and attribute needed
    const { isLoader, getDetail, postData, updateData, detail } = useAction();
    const { getData: getRoles, data: roles } = useActionRoles();
    const { match } = props;
    const idData = match.params.id;

    // initiate form data
    const initialFieldsValues: any = {
        name: "",
        desc: "",
        roles: null
    };

    const [fieldsValues, setFieldsValues]: any = useState(initialFieldsValues);
    const [fieldsSelectRole, setFieldsSelectRole]: any = useState({ id: undefined, name: "", desc: "" });
    const [showModal, setShowModal] = useState(false);
    const [showConfirmation, setShowConfirm] = useState(false);
    const [paramSubmit, setParamSubmit] = useState({});

    // first load
    useEffect(() => {
        fetchRoles();
        if (idData && !detail) {
            getDetail(idData);
        }
        if (idData && detail) {
            setDefault();
        }
    }, [detail])

    // fetch data
    const setDefault = async () => {
        if (detail) {
            setFieldsValues({
                name: detail.name,
                desc: detail.desc,
                active: detail.active,
                roles: detail.roles
            });
        }
    }

    // fetch application
    const fetchRoles = async () => {
        getRoles({ page: 1, limit: 10, all: true });
    }

    // handle submit form
    const handleSubmit = (e: any) => {
        const validateFields = GetValidateFields(fieldsValues);
        const { err, values } = validateFields;
        e.preventDefault();
        if (!err) {
            setParamSubmit(values);
            setShowConfirm(true);
        }
    };

    // role options
    const optionsRoles = roles ? roles.map((tp: IResponseRoles) => <Option key={tp.id} value={tp.id}>{tp.name}</Option>) : null;
    const changeRole = (value: string) => {
        const role = roles && roles.filter((rl: IResponseRoles) => rl.id == value);
        if (role.length > 0) {
            setFieldsSelectRole({ ...fieldsSelectRole, ...role[0], errors: [] });
        }
    }

    const onOk = () => {
        const newRoles = fieldsValues.roles ?? [];
        delete fieldsSelectRole.errors;
        const index = newRoles.findIndex((element: any) => element.id == fieldsSelectRole.id);
        if (index >= 0) {
            newRoles[index] = fieldsSelectRole;
        } else {
            newRoles.push(fieldsSelectRole);
        }
        setFieldsValues({ ...fieldsValues, roles: newRoles })
        setFieldsSelectRole({ id: undefined, name: "", desc: "" });
    }

    const onCancel = () => {
        setShowModal(false);
    }
    // return JSX Element 
    return (
        <LayoutCMS {...layoutCMSProps}>
            <Card className="asumsi-card-form-shadow-rd-15">
                <Form>
                    <Skeleton loading={isLoader}>
                        <Row gutter={30}>
                            <Col lg={{ span: 24 }} md={{ span: 24 }} xs={{ span: 32 }}>
                                <Row>
                                    <Col span={10}>
                                        <FormItem width="90%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Name" labelAlign="left"
                                            fieldDecorator={{
                                                label: "name",
                                                rules: [{
                                                    message: 'Please input name',
                                                    required: true,
                                                }
                                                ]
                                            }}
                                        >
                                            <Input id="name" defaultValue={fieldsValues.name} />
                                        </FormItem>
                                    </Col>
                                    <Col span={7}>
                                        <FormItem width="50%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Active" labelAlign="left"
                                            fieldDecorator={{
                                                label: "active"
                                            }}
                                        >
                                            <Toggle id="active" defaultChecked={fieldsValues.active} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24}>
                                        <FormItem width="96%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Description" labelAlign="left"
                                            fieldDecorator={{
                                                label: "desc"
                                            }}
                                        >
                                            <Input id="desc" defaultValue={fieldsValues.desc} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24}>
                                        {fieldsValues.roles && fieldsValues.roles.map((role: IResponseRoles) =>
                                            <Card className="m-b-10">
                                                <div className="display-flex">
                                                    <div className="title-role">
                                                        {role.name}
                                                    </div>
                                                    <div className="action-delete">
                                                        <Tooltip text="hapus">
                                                            <Button type="default"
                                                                onClick={() => {
                                                                    const newData = fieldsValues.roles;
                                                                    const index = newData.findIndex((element: any) => element.id == role.id);
                                                                    if (index >= 0) {
                                                                        newData.splice(index, 1);
                                                                    }
                                                                    setFieldsValues({ ...fieldsValues, roles: newData })
                                                                }}
                                                            >
                                                                <AsumsiIcon icon="trash" />
                                                            </Button>
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                                <div className="description-role">{role.desc}</div>
                                            </Card>)}
                                        <Card>
                                            <Button iconLeft="plus" className="center" type="primary" size="medium" text="Add Role to Group" onClick={() => setShowModal(true)} />
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Skeleton>
                    <ButtonAction
                        left={
                            <Link to="/user/role-groups">
                                <Button type="outline-red" size="medium" disabled={isLoader} text="Cancel"></Button>
                            </Link>
                        }
                        right={
                            <Button type="green" size="medium" disabled={fieldsValues.errors && fieldsValues.errors.length > 0} loading={isLoader} onClick={handleSubmit}>
                                Save Role Group
                            </Button>
                        }
                    />
                </Form>
                <Confirm
                    key="confirm-save"
                    show={showConfirmation}
                    setShow={setShowConfirm}
                    onOk={async () => {
                        let values: any = paramSubmit;
                        values = {
                            ...values,
                            roles: values.roles ? values.roles.map((role: any) => role.id) : null,
                            active: values.active ? true : false
                        };
                        if (!idData) {
                            // do post data
                            postData(values);
                        } else {
                            // do update data
                            updateData(values, idData);
                        }
                    }}
                    content='Apakah Anda yakin untuk menyimpan data ini?'
                    title='Konfirmasi'
                    okText='Ya'
                    cancelText='Tidak'
                />
                <Modal
                    show={showModal}
                    setShow={setShowModal}
                    title="Select Role"
                    onOk={onOk}
                    okText="Submit"
                    cancelText="Cancel"
                    onCancel={onCancel}
                    actionBottom={true}
                    disableButtonOk={fieldsSelectRole.errors && fieldsSelectRole.errors.length > 0}
                >
                    <Form className="m-r-20 m-l-20 m-t-10">
                        <FormItem width="90%" setFieldsValues={setFieldsSelectRole} fieldsValues={fieldsSelectRole} label="Role" labelAlign="left"
                            fieldDecorator={{
                                label: "id",
                                rules: [{
                                    message: 'Please select role',
                                    required: true,
                                }
                                ]
                            }}
                        >
                            <Select
                                id="id"
                                showSearch
                                style={{ width: "400px" }}
                                onChange={changeRole}
                                allowClear={false}
                                defaultValue={fieldsSelectRole.id}
                                value={fieldsSelectRole.id}
                                optionFilterProp="children"
                                placeholder="Please select role">
                                {optionsRoles}
                            </Select>
                        </FormItem>
                    </Form>
                </Modal>
            </Card>
        </LayoutCMS>
    );
};
export default PageRoleGroupsFormComponent;



// WEBPACK FOOTER //
// ./src/pages/role-groups-form/component.tsx